import React from 'react';
import Page from './components/Page';

const App = () => <Page />;

export default App;
